const CHAT = {
  //  UserListHeader
  ONLINE: "Online",
  OFFLINE: "Offline",
  SETTINGS: "Settings",
  CHANGE_STATUS: "Change Status",
  SORT: "Sort",
  HOME: "Home",
  AGENTS: "Agents",
  ONLINE_USERS: "Online Users",
  UNLIMITED: "Unlimited",
  REMAINING_CONVS: "Remaining Conversations",
  REMAINING: "Remaining",
  SEARCH_IN_CONVS: "Search in Conversations",

  // UserListFilter
  PENDING: "Pending",
  ONGOING: "Ongoing",
  OTHERCONVS: "Other Conversations",
  NEWEST: "Newest",
  OLDEST: "Oldest",

  // UserList
  DELETE_ALL: "Clear All  ?",
  CLOSE_ALL: "Close All  ?",
  UPDATING: "Updating ...",
  THERE_IS_NO_CONV: "There is no conversation",
  SHOW_MORE: "Show More",

  // ConversationsHeader
  TRANSFER_CONV: "Transfer Conversation",
  AGENT_NOT_FOUND: "Agent not found",
  BLACK_LIST: "Move to black list",
  CLOSE_CONV: "Close",
  REJECT_CONV: "Reject",
  ACCEPT_CONV: "Accept",
  UPDATE_CONV: "Update conversation",
  CONV_UPDATED: "Conversation updated",
  TRANSFER_TO_ME: "Transfer",
  ROADMAP: "Roadmap",

  ROADMAP_MODAL: {
    TITLE: "Roadmap",
    ENTER: "Enter",
    TOTAL_TIME: "Total spent time",
    LAST_PAGE: "Last visited page",
    TIME_SPENT: "#time# Was in this page",
    AND: " and ",
  },

  // ConversationsBody
  //
  //

  // ConversationsFooter
  SEARCH_IN_MESSAGES: "Search in messages",
  ADD_MESSAGE: "Add Message +",
  ADD_MESSAGE_TITLE: "Add Shotcut Message",
  MSG_TITLE_PH: "Title",
  MSG_CONTENT_PH: "Content",
  PUBLIC: "Public",
  EDIT_NOT_PERMIT: "Only message creator can edit it",
  VISIBLE_FOR_ALL: "(visible to all teammates)",

  // short messages
  // chat box
  CHAT_INPUT_PH: "Type / to use shortcut messages",
  CHAT_INPUT_SHORT_PH: "Type something ...",
  // send
  SEND: "Send",

  USER_FORM_INFO: "User form info",

  // UserInfoBox
  LOGIN_TO_DASHBOARD: "Login to Dashboard",
  LOGOUT: "Logout",

  EMAIL: "Email",
  PHONE: "Phone",
  ID: "ID",

  COPY: "Copy",
  EIDT: "Edit",
  CANCEL: "Cancel",
  CONFIRM: "Confirm",
  SAVE: "Save",

  DESCRIPTION: "Description",
  NOTES: "Notes",
  DESCRIPTION_PH: "Type something and press ENTER",

  DEPARTMENT: "Department",
  OPERATOR_NAME: "Operator's Name",
  USER_INFOS: "User Information",
  LAST_SEEN: "Last Seen",
  USER_LAST_PAGE: "Last Page",
  LOCKED: "Locked",
  SESSIONS: "Sessions",
  TIME_SPENT_IN_WEBSITE: "Time Spent",
  IP: "IP",
  DEVICE: "Device",
  BROWSER: "Browser",
  PAGE: "Page",
  REFERRAL: "Referral",

  // Common users
  // SEARCH : "Search",
  SEARCH: "Search",
  YOU: "Transfer chat to...",

  THIS_LINK: "this link",
  SELECT_CONV_TO_START_CHAT: "To start chatting accept a conversation.",
  TRANSFER_CONV_TO_ME: "Click to transfer conversation to yourself",
  UPGRADE_YOUR_PACKAGE:
    "To accept this conversation please upgrade your package through #link#",
  CHARGE_YOUR_CONVS:
    "To accept this conversation please charge your conversations through #link#",

  TRANSFERED_CONV_TEXT: "A conversation from #name# transfered to you",
  ACCEPT: "Accept",
  REJECT: "Reject",

  REPLAY: "Reply",
  EDITED: "edited",
  EDITING: "Editing",

  COPY_TEXT: "Copy Text",
  EDIT: "Edit",
  MESSAGE_HAS_BEEN_EDITED: "This message has been edited once before!",
  EDIT_ONLY_LAST_12_HOURS_MESSAGES:
    "Only the messages that has been sent in the last 12 hours are editable!",
  USER_TAG: "User",

  DROP_FILE_HERE: "Drop file here",

  USER_INFO: "User information",

  SURE_WANT_TO_TRANSFER_TO_YOURSELF:
    "Are you sure you want to transfer this conversation to yourself?",

  CONFIRM_BLOCK_TEXT: "Do you want to remove this user from the blacklist?",
};

export default CHAT;
